module.exports = __webpack_public_path__ + "static/img/bE8T2DMw.54095a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cabins/horse-nest/bE8T2DMw.jpg
// module id = wx5z
// module chunks = 7